// BV - update free shipping and free gift progress bars when cart is updated
$(function () {
  if ($('[data-progress-component]').length) {
    xhook.after(function(request, response) {
      if (request && (request.url.includes("/cart/add.js") || request.url.includes("/cart/change.js") || request.url.includes("/cart/update.js") || request.url.includes("/cart/clear.js"))) {
        // get cart info
        $.getJSON(window.root_url + "/cart.js", function (cart) {
          // update gift progress component status
          $('[data-progress-component]').each(function() {
            var component = $(this);
            var qualifying_amount = component.data('qualifying-amount');
            var cart_total = cart.total_price;

            var remaining_amount = qualifying_amount - cart_total;
            var qualified_percentage = (cart_total / qualifying_amount) * 100;

            if (cart_total > qualifying_amount) {
              $('.cart-progress--not-qualified', component).addClass('hidden');
              $('.cart-progress--qualified', component).removeClass('hidden');
            } else {
              $('.cart-progress--not-qualified', component).removeClass('hidden');
              $('.cart-progress--qualified', component).addClass('hidden');

              $('[data-amount-remaining]', component).text(theme.Currency.formatMoney(remaining_amount, '${{amount}}'));
              $('[data-progress-bar]', component).width(qualified_percentage + '%');
            }
          });
        });
      }
    });
  }
});
                                                                       
// BV - bundle product template
$(function() {
  var bundle_container = $('.bundle-container[data-bundle]');
  var bundle_quantity = $('input.product-quantity-input');
  var bundle_atc = $('.bundle-product--submit');

  if (bundle_container.length && bundle_atc.length && bundle_quantity.length) {
    // update total prices on quantity change
    bundle_quantity.on('change', function(e) {
      var quantity = $(this).val();
      if (quantity < 1) {
        $(this).val(1);
        quantity = 1;
      }

      var original_total_price = bundle_container.data('bundle-original-total') * quantity;
      var total_price = bundle_container.data('bundle-total') * quantity;
      
      if (typeof Shopify !== 'undefined' && typeof theme.Currency.formatMoney !== 'undefined') {
        $('[data-bundle-total-price]').text(theme.Currency.formatMoney(total_price));
        $('[data-bundle-original-total-price]').text(theme.Currency.formatMoney(original_total_price));
      }
    });
    bundle_quantity.trigger('change');

    // add bundle products to cart on ATC click
    bundle_atc.on('click', function(e) {
      e.preventDefault();
      var quantity = parseInt(bundle_quantity.val());
      bundle_atc.removeClass('addtocart-button-active').addClass('addtocart-button-loading').prop('disabled', true);

      var requestData = {
        items: []
      };

      $('[data-bundle-item]', bundle_container).each(function() {
        var variant_id = $(this).data('variant-id');
        if (typeof variant_id !== 'undefined ') {
          requestData.items.push({
            id: variant_id,
            quantity: quantity
          });
        }
      });

      $.ajax({
        method: 'POST',
        url: window.root_url + '/cart/add.js',
        data: requestData,
        success: function(response) {
          window.location.assign(window.root_url + '/cart');
        },
        error: function(err) {
          console.log(err);
        }
      })
    });
  }
});
                                                                       
// BV - GWP (Gift With Purchase) feature
(function () {
  if (typeof Bonfire === 'undefined' || typeof Bonfire.gwp_settings === 'undefined') {
    return;
  }

  var customer_wholesale = Bonfire.general_settings.customer_wholesale;

  if (customer_wholesale) {
    var gwp_enabled = Bonfire.gwp_settings.enabled_wholesale;
    var gwp_variant_ids = Bonfire.gwp_settings.variant_ids_wholesale;
    var gwp_variant_id = Bonfire.gwp_settings.variant_id_wholesale;
    var gwp_price_threshold = Bonfire.gwp_settings.price_threshold_wholesale;
  } else {
    var gwp_enabled = Bonfire.gwp_settings.enabled;
    var gwp_variant_ids = Bonfire.gwp_settings.variant_ids;
    var gwp_variant_id = Bonfire.gwp_settings.variant_id;
    var gwp_price_threshold = Bonfire.gwp_settings.price_threshold;
  }

  console.log('Customer Wholesale? ' + customer_wholesale)
  console.log('GWP Enabled? ' + gwp_enabled)
  console.log('IDs: ' + gwp_variant_ids)
  console.log('ID: ' + gwp_variant_id)
  console.log('Price Threshold: ' + gwp_price_threshold)

  if (typeof gwp_variant_id === 'undefined' || typeof gwp_price_threshold === 'undefined') {
    gwp_enabled = false;
  }
  gwp_enabled = true; // force GWP to enabled, disregard old settings 

  // utility function to update cart with GWP product on price change
  async function updateGWP(cart, refreshPage) {
    if (!gwp_enabled) return;
    console.log('updating GWP');
    
    var current_gwp_quantity = 0;
    var cart_total_price_without_gwp = 0;
    var gwp_previously_added = ls.get('gwp_previously_added') ?? false; // cookie to track if GWP was added or removed automatically - if user removes GWP from cart without falling below threshold, this is used to prevent adding GWP automatically
    var active_gwp_variants = [];

    for (var i=0; i<cart.items.length; i++) {
      var currentItem = cart.items[i];
      if (gwp_variant_ids.includes(currentItem.variant_id.toString()) || gwp_variant_id === currentItem.variant_id) {
        current_gwp_quantity += currentItem.quantity;
        active_gwp_variants.push(currentItem.variant_id);
      } else {
        cart_total_price_without_gwp += currentItem.final_line_price;
      }
    }
    
    // disable feature for wholesale customers by forcing current threshold value to -1, which will always remove the GWP product when a wholesale customer logs in
    /*if (customer_wholesale) {
      cart_total_price_without_gwp = -1;
    }*/

    console.log('Cart total price: ' + cart_total_price_without_gwp)
    console.log('Current GWP Quantity: ' + current_gwp_quantity)
    console.log('GWP Previously Added: ' + gwp_previously_added)

    // if incorrect version (wholesale or retail) of GWP product is in cart (meaning wholesale user just logged in or out), remove it and reset previously_added variable.
    let wholesale_gwp_in_cart = false;
    let retail_gwp_in_cart = false;
    for (var i=0; i<cart.items.length; i++) {
      if (cart.items[i].variant_id === Bonfire.gwp_settings.variant_id_wholesale) {
        wholesale_gwp_in_cart = true;
      } else if (cart.items[i].variant_id === Bonfire.gwp_settings.variant_id) {
        retail_gwp_in_cart = true;
      }
    }

    if ((customer_wholesale && retail_gwp_in_cart) || (!customer_wholesale && wholesale_gwp_in_cart)) {
      let gwpVersionRequestData = {
        updates: {}
      };
      
      if (customer_wholesale && retail_gwp_in_cart) {
        gwpVersionRequestData.updates[Bonfire.gwp_settings.variant_id] = 0;
      } else if (!customer_wholesale && wholesale_gwp_in_cart) {
        gwpVersionRequestData.updates[Bonfire.gwp_settings.variant_id_wholesale] = 0;
      }

      try {
        xhook.disable();
        let response = await $.ajax({
          method: 'POST',
          url: '/cart/update.js',
          data: gwpVersionRequestData,
          dataType: 'json'
        });
        ls.remove('gwp_previously_added');
        gwp_previously_added = false;
        document.dispatchEvent(new CustomEvent('cart:build'));
        xhook.enable();
      } catch (error) {
        console.log(error);
        xhook.enable();
      }
    }
    // end removal of incorrect GWP version code block

    // update the cart if qualified for GWP but GWP is not found in cart
    // Additionally, avoid automatically adding the GWP product if it had previously been added and removed without dropping below GWP threshold (if gwp_previously_added localstorage token is set to true)
    if (cart_total_price_without_gwp >= gwp_price_threshold && current_gwp_quantity < 1 && gwp_previously_added === false) {
      console.log('In IF loop!')
      
      var requestData = {
        updates: {}
      };
      requestData.updates[gwp_variant_id] = 1;

      xhook.disable();
      $.ajax({
        method: 'POST',
        url: '/cart/update.js',
        data: requestData,
        dataType: 'json',
        success: function(response) {
          ls.set('gwp_previously_added', true, { ttl: 60*60*2 }); // store token for 2 hours (in seconds) - GWP was added automatically 
          xhook.enable();
          document.dispatchEvent(new CustomEvent('cart:build'));
          if (refreshPage) {
            window.location.assign('/cart');
          }
        },
        error: function(err) {
          xhook.enable();
          console.log(err);
        }
      });
    } else if (cart_total_price_without_gwp >= gwp_price_threshold && current_gwp_quantity > 1) {
      // update the cart if qualified for GWP but GWP quantity is above max threshold, ensuring that total GWP variant quantity is always 1 when qualified.
      var requestData = {
        updates: {}
      };
      for (var i=0; i<active_gwp_variants.length; i++) {
        requestData.updates[active_gwp_variants[i]] = (i === 0) ? 1: 0; // if more than one GWP variant is in the cart, enforce only one GWP product by setting the quantity of the first one to 1, and the rest to 0
      }

      xhook.disable();
      $.ajax({
        method: 'POST',
        url: window.root_url + '/cart/update.js',
        data: requestData,
        dataType: 'json',
        success: function(response) {
          ls.set('gwp_previously_added', true, { ttl: 60*60*2 }); // store token for 2 hours (in seconds) - GWP was reset to quantity of 1 automatically
          xhook.enable();
          document.dispatchEvent(new CustomEvent('cart:build'));
          if (refreshPage) {
            window.location.assign(window.root_url + '/cart');
          }
        },
        error: function(err) {
          xhook.enable();
          console.log(err);
        }
      });
    } else if (cart_total_price_without_gwp < gwp_price_threshold && current_gwp_quantity != 0) {
      // update the cart if necessary, ensuring that GWP variant quantity is 0 when not qualified for offer.
      var requestData = {
        updates: {}
      };
      for (var i=0; i<active_gwp_variants.length; i++) {
        requestData.updates[active_gwp_variants[i]] = 0;
      }

      xhook.disable();
      $.ajax({
        method: 'POST',
        url: '/cart/update.js',
        data: requestData,
        dataType: 'json',
        success: function (response) {
          ls.remove('gwp_previously_added'); // GWP was removed automatically due to falling below threshold
          xhook.enable();
          document.dispatchEvent(new CustomEvent('cart:build'));
          if (refreshPage) {
            window.location.assign(window.root_url + '/cart');
          }
        },
        error: function (err) {
          xhook.enable();
          console.log(err);
        }
      });
    }
  }

  // update GWP when cart page is loaded
  const urlSegments = new URL(window.location).pathname.split('/');
  const lastSegment = urlSegments.pop() || urlSegments.pop(); // handle potential trailing slash

  if (lastSegment === 'cart') {
    $.ajax({
      method: 'GET',
      url: window.root_url + '/cart.js',
      dataType: 'json',
      success: function (response) {
        updateGWP(response, true);
      },
      error: function (err) {
        console.log(err);
      }
    })
  }
                                                                       
  // update GWP when cart is updated
  xhook.after(function(request, response) {
    if (request && (request.url.includes("/cart/add.js") || request.url.includes("/cart/change.js") || request.url.includes("/cart/update.js") || request.url.includes("/cart/clear.js"))) {
      // get cart info
      $.getJSON( window.root_url + "/cart.js", function( cart ) {
        updateGWP(cart, true);
      });
    }
  }); 
})();

$(document).ready(function() {
  $('.tabs li').click(function() {
    $('.tabs li').removeClass('active');
    $(this).addClass('active');
    var index = $(this).index();
    var index_of_one = index + 1;
    $('.tabs-content li').removeClass('active');
    $('.tabs-content li:nth-child('+ index_of_one +')').addClass('active');
  })
});

// BV - connect inline product grid item forms to theme form scripts
$(function() {
  // delay by 1 second just to make sure product recommendations component loads in before initialization
  setTimeout(function() {
    if (typeof window.theme !== 'undefined' && typeof theme.AjaxProduct !== 'undefined' && theme.settings.cartType === 'drawer') {
      var gridItemForms = $('.grid__item.grid-product form.product-single__form');
      if (gridItemForms.length) {
        gridItemForms.each(function(index, element) {
          new theme.AjaxProduct(element);
        });
      }
    }
  }, 1000);
});

// BV - open samples accordion if open previously (save cookie when toggled)
$(function() {
  var samples_element = $('.cart__page .cart-samples-block');
  if (samples_element.length) {
    // save open/closed status to sessionstorage (local cookie that is cleared when tab is closed)
    samples_element.find('button.collapsible-trigger').on('click', function(e) {
      var is_open = $(this).is('.is-open');
      sessionStorage.setItem('samples_accordion_open', is_open ? 'true' : 'false');
    });
    
    // on page load, open accordion of samples_accordion_open is set to true.
    if (sessionStorage.getItem('samples_accordion_open') === 'true') {
      // set all attributes that display an open accordion
      samples_element.find('button.collapsible-trigger').addClass('is-open');
      samples_element.find('.collapsible-trigger__icon').addClass('collapsible-trigger__icon--open');
      samples_element.find('.collapsible-content.collapsible-content--all').addClass('is-open').css('height', 'auto');
    }
  }
});

// BV - enforce wholesale cart checkout limits without page refresh
$(function() {
  var wholesaleCheckoutElement = $('.cart__checkout-wrapper.is-wholesale[data-wholesale-minimum]');
  var wholesaleCheckoutMinimum = 0;
  
  if (wholesaleCheckoutElement.length) {
    wholesaleCheckoutMinimum = wholesaleCheckoutElement.data('wholesale-minimum');
    
    // update visible checkout elements on cart update
    xhook.after(function(request, response) {
      if (request && (request.url.includes("/cart/add.js") || request.url.includes("/cart/change.js") || request.url.includes("/cart/update.js") || request.url.includes("/cart/clear.js"))) {
        $.getJSON( window.root_url + "/cart.js", function( cart ) {
          if (cart.total_price >= wholesaleCheckoutMinimum) {
            $('.wholesale-checkout-disabled', wholesaleCheckoutElement).addClass('hidden');
            $('.wholesale-checkout-enabled', wholesaleCheckoutElement).removeClass('hidden');
          } else {
            $('.wholesale-checkout-disabled', wholesaleCheckoutElement).removeClass('hidden');
            $('.wholesale-checkout-enabled', wholesaleCheckoutElement).addClass('hidden');
          }
        });
      }
    });
  }
});

// BV - add upsell/free gift products to cart on click
// 10-18-26: the Liquid-rendered button state is only as fresh as the last page load, and a disabled <a> still
// fires click, so a second click, a stale tab or the back button could add a 4th sample (or a 2nd of the same
// one). Re-check the live cart before adding and lock the button while the request is in flight.
$(function() {
  if ($('.cart-samples-block').length) {
    var sample_add_in_flight = false;

    $('a[data-atc-on-click]', '.cart-samples-block').on('click', function(e) {
      e.preventDefault();
      var $btn = $(this);
      if (sample_add_in_flight || $btn.hasClass('disabled') || $btn.attr('disabled')) return;
      sample_add_in_flight = true;
      $btn.addClass('disabled');

      var variant_id = parseInt($btn.data('atc-on-click'), 10);
      var $samples_block = $btn.closest('.cart-samples');
      var is_sample = $samples_block.length > 0; // the free-gift block shares this handler but has its own single-gift rule
      var sample_limit = parseInt($samples_block.data('sample-limit'), 10) || 3;

      var reloadCart = function() {
        window.location.assign(window.root_url + '/cart');
      };

      var addItem = function() {
        var requestData = {
          items: [
            {
              id: variant_id,
              quantity: 1
            }
          ]
        };

        xhook.disable();
        $.ajax({
          method: 'POST',
          url: window.root_url + '/cart/add.js',
          data: requestData,
          dataType: 'json',
          success: function (response) {
            ls.set('gwp_previously_added', false, { ttl: 60*60*2 }); // store token for 2 hours (in seconds) - GWP was removed automatically due to falling below threshold
            xhook.enable();
            document.dispatchEvent(new CustomEvent('cart:build'));
            reloadCart();
          },
          error: function (err) {
            xhook.enable();
            console.log(err);
            reloadCart();
          }
        });
      };

      if (!is_sample) {
        addItem();
        return;
      }

      $.getJSON(window.root_url + '/cart.js')
        .done(function(cart) {
          var sample_units = 0;
          var already_in_cart = false;
          for (var i = 0; i < cart.items.length; i++) {
            if (cart.items[i].product_type === 'Samples') sample_units += cart.items[i].quantity;
            if (cart.items[i].variant_id === variant_id) already_in_cart = true;
          }
          if (already_in_cart || sample_units >= sample_limit) {
            // the page was stale - redraw it so the buttons show the real cart state
            reloadCart();
            return;
          }
          addItem();
        })
        .fail(reloadCart);
    });
  }
});

// BV - 10-18-26 enforce the free-sample limit against the live cart on the cart page
// Catches anything the button guard above can't: a sample line at quantity 2+, or more sample units than the
// limit, whether they got there through a stale page or a direct /cart/add.js post. One unit per sample, keeping
// the samples the customer picked first (cart.js lists newest lines first, so walk it backwards); the rest go to 0.
$(function() {
  var $samples_block = $('.cart__page .cart-samples');
  if (!$samples_block.length) return;

  var sample_limit = parseInt($samples_block.data('sample-limit'), 10) || 3;
  var guard_key = 'sample_limit_fix_attempted';
  var last_attempt = parseInt(sessionStorage.getItem(guard_key), 10) || 0;
  if (Date.now() - last_attempt < 10000) return; // we just corrected and reloaded - do not loop if the update did not stick

  $.getJSON(window.root_url + '/cart.js', function(cart) {
    var updates = {};
    var remaining = sample_limit;
    var changed = false;

    for (var i = cart.items.length - 1; i >= 0; i--) {
      var item = cart.items[i];
      if (item.product_type !== 'Samples') continue;
      var allowed = Math.min(item.quantity, 1, remaining);
      remaining -= allowed;
      if (allowed !== item.quantity) {
        updates[item.key] = allowed;
        changed = true;
      }
    }

    if (!changed) return;

    sessionStorage.setItem(guard_key, Date.now().toString());
    xhook.disable();
    $.ajax({
      method: 'POST',
      url: window.root_url + '/cart/update.js',
      data: { updates: updates },
      dataType: 'json',
      success: function (response) {
        xhook.enable();
        document.dispatchEvent(new CustomEvent('cart:build'));
        window.location.assign(window.root_url + '/cart');
      },
      error: function (err) {
        xhook.enable();
        console.log(err);
      }
    });
  });
});

// BV - Clear cart if it only contains the GWP product
(function() {
  console.log('Clearing cart if it only contains the GWP product');
  try {
    if (typeof Bonfire === 'undefined' || typeof Bonfire.gwp_settings === 'undefined') return;

    $.getJSON(window.root_url + '/cart.js', function(cart) {
      if (!cart || cart.item_count !== 1) return;

      var customer_wholesale = Bonfire.general_settings && Bonfire.general_settings.customer_wholesale;
      var gwp_variant_ids = customer_wholesale ? Bonfire.gwp_settings.variant_ids_wholesale : Bonfire.gwp_settings.variant_ids;
      var gwp_variant_id = customer_wholesale ? Bonfire.gwp_settings.variant_id_wholesale : Bonfire.gwp_settings.variant_id;

      var single = cart.items[0];
      var isGwp = (gwp_variant_ids && gwp_variant_ids.includes(single.variant_id.toString())) || single.variant_id === gwp_variant_id;
      if (!isGwp) return;

      $.ajax({
        method: 'POST',
        url: window.root_url + '/cart/clear.js',
        dataType: 'json'
      }).always(function() {
        window.location.reload();
      });
    });
  } catch (e) {}

// BV - Recharge Subscription Widget V2 is an ES module; it does not listen for
// this theme's variant:change event. Forward variant changes to widget.variantId,
// and when the new variant has no selling plans, clear any stale selling_plan
// input/radio so ATC doesn't fail with "Cannot apply selling plan to variant".
(function () {
  document.addEventListener('variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (!v || !v.id) return;

    document.querySelectorAll('recharge-subscription-widget').forEach(function (w) {
      try { w.variantId = v.id; } catch (err) {}
    });

    var hasPlans = Array.isArray(v.selling_plan_allocations) && v.selling_plan_allocations.length > 0;
    if (!hasPlans) {
      document.querySelectorAll('input[name="selling_plan"]').forEach(function (input) {
        if (input.type === 'radio' || input.type === 'checkbox') {
          input.checked = false;
        } else {
          input.value = '';
        }
      });
    }
  });
})();
})();